export default [
// 中文版开始
    // **遗迹馆详情页 【5号坑遗迹馆】
    {
        path: '/fiveDetail',
        name: 'fiveDetail',
        component: resolve => require(['@/view/guide/fiveDetail/zh/index'], resolve),
        meta: {
            title: '5号坑详情',
            notKeepHeader: true,
            path: 'fiveDetail'
        }
    },
    // **遗迹馆详情页 【5号坑遗迹馆】何为考古
    {
        path: '/whyArch',
        name: 'whyArch',
        component: resolve => require(['@/view/guide/fiveDetail/zh/whyArch'], resolve),
        meta: {
            title: '何为考古',
            notKeepHeader: true,
            path: 'whyArch'
        }
    },
    // **遗迹馆详情页 【5号坑遗迹馆】考古家族
    {
        path: '/archFamily',
        name: 'archFamily',
        component: resolve => require(['@/view/guide/fiveDetail/zh/archFamily'], resolve),
        meta: {
            title: '考古家族',
            notKeepHeader: true,
            path: 'archFamily'
        }
    },
    // **遗迹馆详情页 【5号坑遗迹馆】考古知识
    {
        path: '/archKnown',
        name: 'archKnown',
        component: resolve => require(['@/view/guide/fiveDetail/zh/archKnown'], resolve),
        meta: {
            title: '考古知识',
            notKeepHeader: true,
            path: 'archKnown'
        }
    },
    // **遗迹馆详情页 【5号坑遗迹馆】考古准备
    {
        path: '/archprepar',
        name: 'archprepar',
        component: resolve => require(['@/view/guide/fiveDetail/zh/archprepar'], resolve),
        meta: {
            title: '考古知识',
            notKeepHeader: true,
            path: 'archprepar'
        }
    },
    // **遗迹馆详情页 【5号坑遗迹馆】考古发掘
    {
        path: '/archExcava',
        name: 'archExcava',
        component: resolve => require(['@/view/guide/fiveDetail/zh/archExcava'], resolve),
        meta: {
            title: '考古发掘',
            notKeepHeader: true,
            path: 'archExcava'
        }
    },
    // **遗迹馆详情页 【5号坑遗迹馆】文物整理
    {
        path: '/cultureClean',
        name: 'cultureClean',
        component: resolve => require(['@/view/guide/fiveDetail/zh/cultureClean'], resolve),
        meta: {
            title: '文物整理',
            notKeepHeader: true,
            path: 'cultureClean'
        }
    },
    // **遗迹馆详情页 【5号坑遗迹馆】配置工具图文页面
    {
        path: '/toolDetail',
        name: 'toolDetail',
        component: resolve => require(['@/view/guide/fiveDetail/zh/toolDetail'], resolve),
        meta: {
            title: '配置工具',
            notKeepHeader: true,
            path: 'toolDetail'
        }
    },
    // 英文版开始
    {
        path: '/en/fiveDetail',
        name: 'fiveDetail_en',
        component: resolve => require(['@/view/guide/fiveDetail/en/index'], resolve),
        meta: {
            title: '5号坑详情',
            notKeepHeader: true,
            path: 'fiveDetail'
        }
    },
    // **遗迹馆详情页 【5号坑遗迹馆】何为考古
    {
        path: '/en/whyArch',
        name: 'whyArch_en',
        component: resolve => require(['@/view/guide/fiveDetail/en/whyArch'], resolve),
        meta: {
            title: '何为考古',
            notKeepHeader: true,
            path: 'whyArch'
        }
    },
    // **遗迹馆详情页 【5号坑遗迹馆】考古家族
    {
        path: '/en/archFamily',
        name: 'archFamily_en',
        component: resolve => require(['@/view/guide/fiveDetail/en/archFamily'], resolve),
        meta: {
            title: '考古家族',
            notKeepHeader: true,
            path: 'archFamily'
        }
    },
    // **遗迹馆详情页 【5号坑遗迹馆】考古知识
    {
        path: '/en/archKnown',
        name: 'archKnown_en',
        component: resolve => require(['@/view/guide/fiveDetail/en/archKnown'], resolve),
        meta: {
            title: '考古知识',
            notKeepHeader: true,
            path: 'archKnown'
        }
    },
    // **遗迹馆详情页 【5号坑遗迹馆】考古准备
    {
        path: '/en/archprepar',
        name: 'archprepar_en',
        component: resolve => require(['@/view/guide/fiveDetail/en/archprepar'], resolve),
        meta: {
            title: '考古知识',
            notKeepHeader: true,
            path: 'archprepar'
        }
    },
    // **遗迹馆详情页 【5号坑遗迹馆】考古发掘
    {
        path: '/en/archExcava',
        name: 'archExcava_en',
        component: resolve => require(['@/view/guide/fiveDetail/en/archExcava'], resolve),
        meta: {
            title: '考古发掘',
            notKeepHeader: true,
            path: 'archExcava'
        }
    },
    // **遗迹馆详情页 【5号坑遗迹馆】文物整理
    {
        path: '/en/cultureClean',
        name: 'cultureClean_en',
        component: resolve => require(['@/view/guide/fiveDetail/en/cultureClean'], resolve),
        meta: {
            title: '文物整理',
            notKeepHeader: true,
            path: 'cultureClean'
        }
    },
    // **遗迹馆详情页 【5号坑遗迹馆】配置工具图文页面
    {
        path: '/en/toolDetail',
        name: 'toolDetail_en',
        component: resolve => require(['@/view/guide/fiveDetail/en/toolDetail'], resolve),
        meta: {
            title: '配置工具',
            notKeepHeader: true,
            path: 'toolDetail'
        }
    },
    // 意大利文开始
    {
        path: '/Italian/fiveDetail',
        name: 'fiveDetail_Italian',
        component: resolve => require(['@/view/guide/fiveDetail/Italian/index'], resolve),
        meta: {
            title: '5号坑详情',
            notKeepHeader: true,
            path: 'fiveDetail'
        }
    },
    // **遗迹馆详情页 【5号坑遗迹馆】何为考古
    {
        path: '/Italian/whyArch',
        name: 'whyArch_Italian',
        component: resolve => require(['@/view/guide/fiveDetail/Italian/whyArch'], resolve),
        meta: {
            title: '何为考古',
            notKeepHeader: true,
            path: 'whyArch'
        }
    },
    // **遗迹馆详情页 【5号坑遗迹馆】考古家族
    {
        path: '/Italian/archFamily',
        name: 'archFamily_Italian',
        component: resolve => require(['@/view/guide/fiveDetail/Italian/archFamily'], resolve),
        meta: {
            title: '考古家族',
            notKeepHeader: true,
            path: 'archFamily'
        }
    },
    // **遗迹馆详情页 【5号坑遗迹馆】考古知识
    {
        path: '/Italian/archKnown',
        name: 'archKnown_Italian',
        component: resolve => require(['@/view/guide/fiveDetail/Italian/archKnown'], resolve),
        meta: {
            title: '考古知识',
            notKeepHeader: true,
            path: 'archKnown'
        }
    },
    // **遗迹馆详情页 【5号坑遗迹馆】考古准备
    {
        path: '/Italian/archprepar',
        name: 'archprepar_Italian',
        component: resolve => require(['@/view/guide/fiveDetail/Italian/archprepar'], resolve),
        meta: {
            title: '考古知识',
            notKeepHeader: true,
            path: 'archprepar'
        }
    },
    // **遗迹馆详情页 【5号坑遗迹馆】考古发掘
    {
        path: '/Italian/archExcava',
        name: 'archExcava_Italian',
        component: resolve => require(['@/view/guide/fiveDetail/Italian/archExcava'], resolve),
        meta: {
            title: '考古发掘',
            notKeepHeader: true,
            path: 'archExcava'
        }
    },
    // **遗迹馆详情页 【5号坑遗迹馆】文物整理
    {
        path: '/Italian/cultureClean',
        name: 'cultureClean_Italian',
        component: resolve => require(['@/view/guide/fiveDetail/Italian/cultureClean'], resolve),
        meta: {
            title: '文物整理',
            notKeepHeader: true,
            path: 'cultureClean'
        }
    },
    // **遗迹馆详情页 【5号坑遗迹馆】配置工具图文页面
    {
        path: '/Italian/toolDetail',
        name: 'toolDetail_Italian',
        component: resolve => require(['@/view/guide/fiveDetail/Italian/toolDetail'], resolve),
        meta: {
            title: '配置工具',
            notKeepHeader: true,
            path: 'toolDetail'
        }
    }
]



// WEBPACK FOOTER //
// ./src/router/module/RouterFive.js